
import { useState } from "react";

import { FilledButton, OutlinedButton } from "../../common/Button";

import Lightbox from "../../common/Lightbox";

import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import useMyProjects from "../../../hooks/useMyProjects";
import { DisplayNotificationType } from "../../../models/DisplayNotification";

import { MdOutlineDeleteOutline } from "react-icons/md";
import { ITask } from "../../../data_models/task";
import useProjectManagement from "../../../hooks/useProjectManagement";
import useTasks from "../../../hooks/useTasks";
import { IProject } from "../../../data_models/project";


interface ConfirmDeleteTaskLightboxProps {
    task: ITask;
    onClose: () => void;
    replaceTasks: (tasks: ITask[]) => void;
    onUpdateProject: (project: IProject) => void;
}

export const ConfirmDeleteTaskLightbox: React.FC<ConfirmDeleteTaskLightboxProps> = ({ task, onClose, replaceTasks, onUpdateProject }) => {

    const [loading, setLoading] = useState(false);
    const { deleteTask } = useTasks();
    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();

    const onDeleteDraft = async () => {
        try {
            setLoading(true);
            const result = await deleteTask(task._id!);
            addSuccessNotification('Task deleted successfully', 'Task Deleted');
            replaceTasks(result.tasks);
            onUpdateProject(result.project);
        } catch (error: any) {
            addErrorNotification(error.message, 'Delete Task Failed');
        } finally {
            setLoading(false);
            onClose();
        }
    }


    return (
        <Lightbox
            header="Delete Task"
            confirmText="Delete"
            onCancel={onClose}
            onConfirm={onDeleteDraft}
            loadingConfirm={loading}
            confirmTheme="danger"
            content={<p>This will permanently delete this task. This action cannot be undone.</p>}
            onClose={onClose}
        />
    );
}

